import React from 'react'
import { AlertTriangle } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CombinedInventoryNoticesProps {
  /** Server-composed sentences (App::CombinedInventoryNotices). Rendered verbatim; empty renders nothing. */
  notices: string[] | undefined
  className?: string
  style?: React.CSSProperties
}

/**
 * What is true now about a combined inventory and needs the operator: a Same-room rate plan pair a
 * structure sync has made unsound (that plan is not priced), or a following listing with Same rooms
 * that does not publish while the lead does. Shown on the combined inventory settings page and on the
 * lead's Rooms Setup, beside the Same rooms. Every word is the server's; this only lays it out.
 */
export default function CombinedInventoryNotices({ notices, className, style }: CombinedInventoryNoticesProps) {
  if (!notices || notices.length === 0) return null

  return (
    <div
      role="status"
      className={cn('space-y-1.5 rounded-xl border border-amber-200/70 bg-amber-50 px-4 py-3', className)}
      style={style}
    >
      {notices.map((sentence) => (
        <p key={sentence} className="flex items-start gap-2 text-xs leading-relaxed text-amber-800">
          <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-500" aria-hidden="true" />
          <span>{sentence}</span>
        </p>
      ))}
    </div>
  )
}
